import { render } from "./EditQuoteProduct.vue?vue&type=template&id=06958c93&scoped=true"
import script from "./EditQuoteProduct.vue?vue&type=script&lang=js"
export * from "./EditQuoteProduct.vue?vue&type=script&lang=js"

import "./EditQuoteProduct.vue?vue&type=style&index=0&id=06958c93&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06958c93"]])

export default __exports__